import { useState } from 'react';
import { AlertDialog, AlertDialogContent } from '@/components/ui/alert-dialog';
import CandidatesJobPostEndpointsNewModalAddContents from './CandidatesJobPostEndpointsNewModalAddContents';
import CandidatesJobPostEndpointsNewModalConfirmContents from './CandidatesJobPostEndpointsNewModalConfirmContents';
import type {
  AgentApiProvidedJobPostsRecord,
  AgentApiSharedJobPostsItem,
  AgentApiCandidateEndpointsCopySourceCandidate,
} from '@/types/serializers';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  candidateProfileId: number;
  onSuccess: () => void;
};

export default function CandidatesJobPostEndpointsNewModal({
  open,
  onOpenChange,
  candidateProfileId,
  onSuccess,
}: Props) {
  const [step, setStep] = useState<'add' | 'confirm'>('add');
  const [selectedJobPosts, setSelectedJobPosts] = useState<AgentApiProvidedJobPostsRecord[]>([]);
  const [selectedSharedJobPosts, setSelectedSharedJobPosts] = useState<
    AgentApiSharedJobPostsItem[]
  >([]);
  const [copySourceCandidate, setCopySourceCandidate] =
    useState<AgentApiCandidateEndpointsCopySourceCandidate | null>(null);

  const handleClose = () => {
    setStep('add');
    setSelectedJobPosts([]);
    setSelectedSharedJobPosts([]);
    setCopySourceCandidate(null);
    onOpenChange(false);
  };

  const handleSuccess = () => {
    onSuccess();
    setStep('add');
    setSelectedJobPosts([]);
    setSelectedSharedJobPosts([]);
    setCopySourceCandidate(null);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-max p-0">
        {step === 'add' && (
          <CandidatesJobPostEndpointsNewModalAddContents
            setStep={setStep}
            close={handleClose}
            candidateProfileId={candidateProfileId}
            selectedJobPosts={selectedJobPosts}
            setSelectedJobPosts={setSelectedJobPosts}
            selectedSharedJobPosts={selectedSharedJobPosts}
            setSelectedSharedJobPosts={setSelectedSharedJobPosts}
            copySourceCandidate={copySourceCandidate}
            setCopySourceCandidate={setCopySourceCandidate}
          />
        )}
        {step === 'confirm' && (
          <CandidatesJobPostEndpointsNewModalConfirmContents
            setStep={setStep}
            selectedJobPosts={selectedJobPosts}
            selectedSharedJobPosts={selectedSharedJobPosts}
            candidateProfileId={candidateProfileId}
            close={() => onOpenChange(false)}
            onSuccess={handleSuccess}
          />
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}
